<template>
  <div class="login-box">
    <div class="f32 color-333 mt100 fb">您好,</div>
    <div class="f32 color-333 fb">欢迎来到更新学堂</div>
    <div class="phone-content">
      <gxxt-input
        type="text"
        label="手机号码"
        label-direction="vertical"
        placeholder="请输入手机号"
        v-model="mobile"
        maxlength="11"
        text-align="left"
        clearable
      ></gxxt-input>
    </div>
    <div class="flex-box">
      <div class="input-wrap">
        <gxxt-input
          :label="'验证码'"
          label-direction="vertical"
          text-align="left"
          type="text"
          v-model="code"
          placeholder="请输入验证码"
          maxlength="4"
        ></gxxt-input>
      </div>
      <span
        v-if="!getCodeFlag"
        class="default-c"
        :class="mobileFlag?'hover-c':''"
        @click="getVerification"
      >获取验证码</span>
      <span v-else class="default-c">{{codeNum}}秒后发送</span>
    </div>
    <gxxt-button class="w610" type="primary" :disabled="!mobileFlag" @click="submit">登录</gxxt-button>
    <div class="color-A f24 tc pt30">首次登录即为您注册账号</div>
    <div class="c-footer">
      <gxxt-checkbox outline v-model="agree" style="transform: scale(0.8)"></gxxt-checkbox>登录即代表同意更新学堂
      <a href="https://privacy.bijixia.net/">用户协议</a>和
      <a href="https://protocal.bijixia.net/">隐私政策</a>
    </div>
  </div>
</template>

<script>
import { GxxtCheckbox, GxxtInput, GxxtButton } from '@/components'
export default {
  components: { GxxtCheckbox, GxxtInput, GxxtButton },
  data() {
    return {
      data: '',
      url: '',
      info: [],
      mobile: '',
      code: '',
      mobileFlag: false,
      codeData: '',
      getCodeFlag: false,
      codeNum: 60,
      agree: true,
    }
  },
  created() {
    this.login()
  },
  watch: {
    mobile(value) {
      var phone = value.replace(/\s/g, '') //去除空格
      //校验手机号，号段主要有(不包括上网卡)：130~139、150~153，155~159，180~189、170~171、176~178。14号段为上网卡专属号段
      let regs =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (value.length == 11) {
        if (regs.test(phone)) {
          this.mobileFlag = true
        }
      }
    },
  },
  methods: {
    async login() {
      this.data = window.document.location.href
      this.url = decodeURIComponent(this.data.split('reURL=')[1])
      let res = await this.api.login.ticket()
      // reURL
      if (res.code == 200 && res.data.id) {
        window.location.href = this.url
      } else {
        this.$toaster({
          message: res.message,
        })
      }
    },
    //获取验证码
    getVerification() {
      if (this.mobileFlag) {
        this.getCode()
      }
    },
    async getCode() {
      this.mobileFlag = false
      let res = await this.api.login.code(this.mobile)
      if (res && res.code == 200) {
        this.codeData = res.data
        this.mobileFlag = true
        this.getCodeFlag = true
        this.time = setInterval(() => {
          if (this.codeNum > 0) {
            this.codeNum = this.codeNum - 1
          } else {
            this.getCodeFlag = false
            clearInterval(this.time)
            this.codeNum = 60
          }
        }, 1000)
      } else {
        this.$toaster({
          message: res.message,
        })
      }
    },
    //绑定(手机号
    submit() {
      if (!this.agree) {
        this.$toaster({
          message: '请勾选用户协议和隐私政策',
        })
        return
      }
      if (this.mobileFlag) {
        if (this.code !== '') {
          this.getBind()
        } else {
          this.$toaster({
            message: '验证码不能为空',
          })
        }
      }
    },
    async getBind() {
      this.mobileFlag = false
      let data = {
        mobile: this.mobile,
        code: this.code,
      }
      let res = await this.api.login.bind(data)
      this.info = res
      if (res && res.code == 200) {
        this.mobileFlag = true
        window.location.href = this.url
      } else {
        this.$toaster({
          message: res.message,
        })
        clearInterval(this.time)
        this.code = ''
        this.mobileFlag = true
        this.getCodeFlag = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #aaaaaa;
}

::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #aaaaaa;
}

input:-ms-input-placeholder {
  color: #aaaaaa;
}

input::-webkit-input-placeholder {
  color: #aaaaaa;
}

.login-box {
  padding: 0 70px;
  text-align: left;
  font-size: 28px;
  .phone-content {
    margin-top: 70px;
  }
  .flex-box {
    width: 610px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .input-wrap {
      flex: 400px 0 0;
      font-size: 28px;
    }

    .default-c {
      flex: 180px 0 0;
      color: #aaaaaa;
      border: 2px solid #aaaaaa;
      height: 70px;
      line-height: 70px;
      border-radius: 8px;
      text-align: center;
    }

    .hover-c {
      color: #ff5500;
      border: 2px solid #ff5500;
    }
  }
  .w610 {
    width: 610px;
    margin-top: 60px;
  }
  // .login-btn {
  //   width: 610px;
  //   height: 90px;
  //   line-height: 90px;
  //   font-size: 36px;
  //   color: #ffffff;
  //   text-align: center;
  //   margin: 80px 0 50px 0;
  //   // background: linear-gradient(90deg, #FF8E00 0%, #FF5500 100%);
  //   border-radius: 16px;
  // }
  // .submit-h-c {
  //   background: linear-gradient(90deg, #d6d6d6 0%, #c1c1c1 100%);
  //   opacity: 0.49;
  // }
  // .submit-c {
  //   background: linear-gradient(90deg, #ff8e00 0%, #ff5500 100%);
  // }
}
.c-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 84px;
  line-height: 24px;
  font-size: 24px;
  color: #aaaaaa;
  a {
    color: #f50;
  }
}
</style>
